var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36016 2.3C11.1326 2.30536 12.8412 2.96272 14.1602 4.1468V2.3H15.3602V5.3858C15.3598 5.68121 15.2423 5.96442 15.0335 6.17331C14.8246 6.38219 14.5414 6.49968 14.246 6.5H11.1602V5.3H13.6328C12.6576 4.31214 11.3697 3.69356 9.98903 3.54994C8.60839 3.40631 7.22072 3.74657 6.06312 4.51257C4.90552 5.27856 4.04983 6.42276 3.64225 7.74967C3.23467 9.07657 3.3005 10.5038 3.82849 11.7876C4.35647 13.0713 5.31386 14.1319 6.53705 14.7881C7.76025 15.4443 9.17335 15.6554 10.5349 15.3853C11.8965 15.1152 13.122 14.3807 14.0021 13.3072C14.8822 12.2338 15.3622 10.8881 15.3602 9.5H16.5602C16.5602 10.924 16.1379 12.3161 15.3467 13.5001C14.5556 14.6841 13.4311 15.607 12.1155 16.1519C10.7999 16.6969 9.35217 16.8395 7.95551 16.5617C6.55885 16.2838 5.27593 15.5981 4.26899 14.5912C3.26205 13.5842 2.57632 12.3013 2.29851 10.9046C2.02069 9.50799 2.16328 8.06031 2.70823 6.74468C3.25318 5.42905 4.17602 4.30456 5.36005 3.51342C6.54409 2.72227 7.93613 2.3 9.36016 2.3Z",
    fill: "#0464B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75977 6.50001V9.74841L10.7356 11.7242L11.584 10.8758L9.95977 9.25161V6.50001H8.75977Z",
    fill: "#0464B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlue);
export default __webpack_public_path__ + "static/media/clockBlue.250904981b3acee16416f08864e349a3.svg";
export { ForwardRef as ReactComponent };